import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { ChapterWiseModel } from "../entities/chapter-wise-model.entity";

@Injectable()
export class ChapterWiseModelRepo extends Repository<ChapterWiseModel>{
    constructor(private dataSource: DataSource) {
        super(ChapterWiseModel, dataSource.createEntityManager());
    }
}